import React from 'react';
import DAC7List from "./List/DAC7List";

function DAC7(props) {
    return <DAC7List />;
}

export default DAC7;
